/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import InstagramIcon from "@mui/icons-material/Instagram";
import PinterestIcon from "@mui/icons-material/Pinterest";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Iconify from "components/iconify";
import { TICKER } from "utils/constants";
import boxShadow from "assets/theme/functions/boxShadow";
import { DISCORD, GITHUB, TELEGRAM, TIKTOK, TWITTER } from "../../../utils/constants";

function CenteredFooter(props) {
  const {
    company = {
      href: "https://fartlab.app/",
      name: "The AI FartLab",
    },
    links = [
      { href: "/app", name: "The App" },
      // { href: "/buy", name: "Buy " + TICKER},
      { href: "/team", name: "The Team" },
      { href: "/privacy-policy", name: "Privacy Policy" },
      { href: "/terms-and-conditions", name: "Terms of Use" },
    ],
    socials = [
      {
        icon: <Iconify icon="hugeicons:new-twitter-ellipse" width={24} height={24} />,
        link: TWITTER,
      },
      {
        icon: <Iconify icon="hugeicons:tiktok" width={24} height={24} />,
        link: TIKTOK,
      },
      {
        icon: <Iconify icon="hugeicons:discord" width={24} height={24} />,
        link: DISCORD,
      },
      {
        icon: <Iconify icon="hugeicons:telegram" width={24} height={24} />,
        link: TELEGRAM,
      },
      // TODO: Add it again when repo is public
      // {
      //   icon: <Iconify icon="hugeicons:github" width={24} height={24} />,
        // link: GITHUB,
      // },
    ],
    light = false,
  } = props;

  const { href, name } = company;

  const year = new Date().getFullYear();

  const renderLinks = links.map((link) => (
    <MKTypography
      key={link.name}
      component={Link}
      href={link.href}
      variant="body2"
      color={light ? "white" : "black"}
      fontWeight="regular"
      sx={{ textShadow: light ? "" : "1px 1px white" }}
    >
      {link.name}
    </MKTypography>
  ));

  const renderSocials = socials.map((social) => (
    <MKTypography
      key={social.link}
      component={Link}
      href={social.link}
      variant="body2"
      color={light ? "white" : "black"}
      sx={{ textShadow: light ? "" : "1px 1px white" }}
      fontWeight="regular"
    >
      {social.icon}
    </MKTypography>
  ));

  return (
    <MKBox component="footer" py={6}>
      <Grid container justifyContent="center">
        <Grid item xs={10} lg={8}>
          <Stack
            direction="row"
            flexWrap="wrap"
            justifyContent="center"
            spacing={{ xs: 2, lg: 3, xl: 6 }}
            mb={3}
          >
            {renderLinks}
          </Stack>
        </Grid>
        <Grid item xs={12} lg={8}>
          <Stack display="flex" direction="row" justifyContent="center" spacing={3} mt={1} mb={3}>
            {renderSocials}
          </Stack>
        </Grid>
        <Grid item xs={12} lg={8} sx={{ textAlign: "center" }}>
          <MKTypography
            variant="body2"
            color={light ? "white" : "black"}
            sx={{ textShadow: light ? "" : "1px 1px white" }}
          >
            Copyright &copy; {year} by{" "}
            <MKTypography
              component={Link}
              href={href}
              target="_blank"
              rel="noreferrer"
              variant="body2"
              color={light ? "white" : "black"}
              sx={{ textShadow: light ? "" : "1px 1px white" }}
            >
              {name}
            </MKTypography>
            .
          </MKTypography>
        </Grid>
      </Grid>
    </MKBox>
  );
}


export default CenteredFooter;
